// @flow
import * as React from 'react';
import * as API from '../../api';
import Validators, { IValidatorPackage } from '../../Validators';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import RadioGroup from '../RadioGroup/RadioGroup';
import { withLocalize, Translate } from "react-localize-redux";

import './LocationSelection.css';

interface ILocationSelectionProps {
    location: number;
    locationsData: API.Dictionary<API.ILocationData>;
    handleClickBack: () => void;
    handleClickNext: () => void;
    updateLocation: (value: number) => void;
}

interface ILocationSelectionState {
    deferErrors: boolean;
}

class LocationSelection extends React.Component<ILocationSelectionProps, ILocationSelectionState> {
    validators: {
        [key: string]: IValidatorPackage[];
        location: IValidatorPackage[];
    };

    constructor(props: ILocationSelectionProps) {
        super(props);

        this.state = {
            deferErrors: true
        };

        this.validators = {
            location: [{
                validator: Validators.nonNegativeInteger,
                errorMessage: <Translate id="constants_js.required"/>
            }]
        };
    }

    validate() {
        const validatorKeys = Object.keys(this.validators);
        for (let i = 0; i < validatorKeys.length; i++) {
            const prop = validatorKeys[i];
            const validators = this.validators[prop];
            for (let j = 0; j < validators.length; j++) {
                const validatorPackage = validators[j];
                if (validatorPackage.validator(this.props[prop]) === false) {
                    return false;
                }
            }
        }

        return true;
    }

    onLocationChange = (value: string) => {
        if (!isNaN(parseInt(value, 10))) {
            this.props.updateLocation(parseInt(value, 10));
        }
    }

    onClickBack = () => {
        this.props.handleClickBack();
    }

    onClickNext = () => {
        if (this.validate()) {
            this.props.handleClickNext();
        }
        else {
            this.setState({ deferErrors: false });
        }
    }

    render() {
        // Display in alphabetic order
        const locationKeys = Object.keys(this.props.locationsData);
        const locations = locationKeys.map((key, index) => {
            return this.props.locationsData[key];
        });
        locations.sort((a, b) => { 
            if (a.displayName < b.displayName) {
                return -1;
            }
            if (a.displayName > b.displayName) {
                return 1;
            }
            return 0;
        });
        const locationNames = locations.map((location, index) => {
            return location.displayName;
        });
        const locationIds = locations.map((location, index) => {
            return location.locationId.toString();
        });
        return (
            <div className={'LocationSelection'}>
                <Header
                    header={<Translate id="location_selection_js.header"/>}
                    subHeader={<Translate id="location_selection_js.sub_header"/>}
                />
                <RadioGroup
                    label={<Translate id="location_selection_js.label_which_location"/>}
                    selectedValue={this.props.location.toString()}
                    handleChange={this.onLocationChange}
                    optionLabels={locationNames}
                    optionValues={locationIds}
                    required={true}
                    deferErrors={this.state.deferErrors}
                    validators={this.validators.location}
                />
                <Footer
                    nextEnabled={this.state.deferErrors === true || this.validate()}
                    handleClickBack={this.onClickBack}
                    handleClickNext={this.onClickNext}
                    nextText={<Translate id="footer_js.next"/>}
                    backText={<Translate id="footer_js.back"/>}
                />
            </div>
        );
    }
}

export default withLocalize(LocationSelection);
// export default LocationSelection;
